import fastSafeStringify from "fast-safe-stringify";

/**
 * Like `JSON.stringify`, but handles circular references instead of throwing.
 * Uses native JSON.stringify when possible for performance, falling back to
 * fast-safe-stringify for objects it doesn't natively support.
 */
export function safeStringify(o: unknown): string {
	try {
		return JSON.stringify(o);
	} catch {
		return fastSafeStringify(o);
	}
}
